import { Radio, type RadioProps } from '@chakra-ui/react';

export type UiRadioProps = RadioProps;

export const UiRadio = Radio;
